export var INITIAL_MODAL_TIMER = 15000;
export var SALON_CONFERENCE_WEBSITE_PRODUCT_TYPE = 'Salon Conference Website';
export var BASIC_ALLOWED_LEAD_SOURCE = 'ChowNow';
export var BASIC_PACKAGE_NAME = 'Basic';
export var ANNUAL_PRICE_PERIOD = 'annually';
export var MONTHLY_PRICE_PERIOD = 'monthly';
export var ALL_INCLUDED = 'All-Included';
export var DASHBOARD_URL = 'https://app.gofisherman.com/';
export var FISHERMAN_BRAND_IDENTITY = 'FISH';
export var GLAMMATIC_BRAND_IDENTITY = 'GLAM';